/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
// eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
import type { Store } from 'redux';
import type PlanDependenciesReportType from '@jira/spa-apps__advanced-roadmaps-plan-dependencies-report/src/PlanDependenciesReport.tsx';
import type PlanIncrementType from '@jira/spa-apps__advanced-roadmaps-plan-increment/src/PlanIncrement.tsx';
import type PlanSummaryType from '@jira/spa-apps__advanced-roadmaps-plan-summary/src/PlanSummaryWithErrorBoundary.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyPlanSummaryEmbed: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof PlanSummaryType
>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-plan-summary-embed-old", jiraSpaEntry: "async-plan-summary-embed-old" */ '@jira/spa-apps__advanced-roadmaps-plan-summary/src/PlanSummaryWithErrorBoundary.tsx'
			),
		),
	{ ssr: false },
);

export const PlanSummaryEmbedPage = (): React.JSX.Element => (
	<LazyPage Page={LazyPlanSummaryEmbed} pageId="plan-summary-embed-old" shouldShowSpinner />
);

export const LazyPlanDependenciesReportEmbed: LazyComponent<
	({ store }: { store: Store }) => React.JSX.Element
> = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyForPaint<typeof PlanDependenciesReportType>(
		() =>
			markAsProductBundleReady(
				import(
					/* webpackChunkName: "async-plan-dependencies-report-embed-old", jiraSpaEntry: "async-plan-dependencies-report-embed-old" */ '@jira/spa-apps__advanced-roadmaps-plan-dependencies-report/src/PlanDependenciesReport.tsx'
				),
			),
		{ ssr: false },
	);

export const PlanDependenciesReportEmbedPage = (): React.JSX.Element => (
	<LazyPage
		Page={LazyPlanDependenciesReportEmbed}
		pageId="plan-dependencies-report-embed-old"
		shouldShowSpinner
	/>
);

export const LazyPlanIncrementEmbed: LazyComponent<
	({ store }: { store: Store }) => React.JSX.Element
> = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyForPaint<typeof PlanIncrementType>(
		() =>
			markAsProductBundleReady(
				import(
					/* webpackChunkName: "async-plan-increment-embed-old", jiraSpaEntry: "async-plan-increment-embed-old" */ '@jira/spa-apps__advanced-roadmaps-plan-increment/src/PlanIncrement.tsx'
				),
			),
		{ ssr: false },
	);

export const PlanIncrementEmbedPage = (): React.JSX.Element => (
	<LazyPage Page={LazyPlanIncrementEmbed} pageId="plan-increment-embed-old" shouldShowSpinner />
);
